// Discogs types and selling providers
// =============================================================================
// SHIPPING CARRIERS
// =============================================================================
export const SHIPPING_CARRIERS = [
    { id: 'canadapost', name: 'Canada Post' },
    { id: 'usps', name: 'USPS' },
    { id: 'ups', name: 'UPS' },
    { id: 'fedex', name: 'FedEx' },
    { id: 'dhl', name: 'DHL' },
    { id: 'other', name: 'Other' },
];
// =============================================================================
// SELLING PROVIDERS
// =============================================================================
export const SELLING_PROVIDERS = [
    { id: 'ebay', name: 'eBay', icon: 'shopping-cart' },
    { id: 'discogs', name: 'Discogs', icon: 'disc' },
    { id: 'facebook', name: 'Facebook Marketplace', icon: 'facebook' },
];
// =============================================================================
// DISCOGS CONDITIONS
// =============================================================================
// Discogs uses the Goldmine grading standard for media condition
export const DISCOGS_MEDIA_CONDITIONS = [
    { id: 'Mint (M)', name: 'Mint (M)', description: 'Perfect, unplayed condition' },
    { id: 'Near Mint (NM or M-)', name: 'Near Mint (NM or M-)', description: 'Nearly perfect with minimal signs of handling' },
    { id: 'Very Good Plus (VG+)', name: 'Very Good Plus (VG+)', description: 'Shows some signs of wear but plays well' },
    { id: 'Very Good (VG)', name: 'Very Good (VG)', description: 'Surface noise evident but does not overpower music' },
    { id: 'Good Plus (G+)', name: 'Good Plus (G+)', description: 'Significant surface noise and wear' },
    { id: 'Good (G)', name: 'Good (G)', description: 'Plays through without skipping but heavy wear' },
    { id: 'Fair (F)', name: 'Fair (F)', description: 'Barely acceptable, may skip' },
    { id: 'Poor (P)', name: 'Poor (P)', description: 'Damaged, may not play through' },
];
// Sleeve/cover condition options
export const DISCOGS_SLEEVE_CONDITIONS = [
    { id: 'Mint (M)', name: 'Mint (M)', description: 'Perfect condition' },
    { id: 'Near Mint (NM or M-)', name: 'Near Mint (NM or M-)', description: 'Nearly perfect' },
    { id: 'Very Good Plus (VG+)', name: 'Very Good Plus (VG+)', description: 'Minor wear' },
    { id: 'Very Good (VG)', name: 'Very Good (VG)', description: 'Visible wear' },
    { id: 'Good Plus (G+)', name: 'Good Plus (G+)', description: 'Significant wear' },
    { id: 'Good (G)', name: 'Good (G)', description: 'Heavy wear' },
    { id: 'Fair (F)', name: 'Fair (F)', description: 'Major damage' },
    { id: 'Poor (P)', name: 'Poor (P)', description: 'Severely damaged' },
    { id: 'Generic', name: 'Generic', description: 'Generic replacement sleeve' },
    { id: 'Not Graded', name: 'Not Graded', description: 'No sleeve or not applicable' },
];
//# sourceMappingURL=discogs.js.map